import {
    animate,
    style,
    transition,
    trigger,
  } from '@angular/animations';
  
  export const ROUTE_ANIMATION_HOST = { '[@routeAnimation]': 'true' };
  
  export const ROUTE_ANIMATION =
    trigger('routeAnimation', [
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(6%)',
        }),
        animate('0.35s cubic-bezier(0.550, 0.055, 0.675, 0.190)'),
      ]),
      transition(':leave', [
        style({
          opacity: 0,
        }),
      ]),
    ]);